import { Avatar } from '@mui/material'
import React from 'react'
import { stringAvatar } from 'utils/functions/common'

const AvatarUser = ({user, sx}) => {
    if(user?.images) {
        return (
            <img width={40} height={40} style={{ borderRadius: '50%', margin: 0 , ...sx}} src={user.images} alt='ava' />
        )
    } else if(user?.bgrColor) {
        return (
            <Avatar  style={{ margin: 0 }} {...stringAvatar(user.username, user, false, sx, '40px', '40px', '36px')}/>
        )
    } else {
        return (
            <Avatar sx={sx}/>
        )
    }
}

export default AvatarUser